import * as api from "../Api/index";
import { loadFailed } from "../utils/errorMessage";
export const getRightOfUseAsset = () => async (dispatch) => {
  try {
    const { data } = await api.getRightOfUseAsset();
    dispatch({ type: "GET_ALL_RIGHT_OF_USE_ASSET", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};
